import client from '../client';
import type { Customer } from '../../types/customer';
import type { ApiResponse, PaginationParams } from '../../types/api';

interface CustomerListParams extends PaginationParams {
  sort?: 'asc' | 'desc';
  startDate?: string;
  endDate?: string;
  search?: string;
}

export const customersApi = {
  list: async (storeId: string, params?: CustomerListParams) => {
    const res = await client.get<ApiResponse<{ customers: Customer[]; pagination: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/customers`,
      { params },
    );
    return res.data.data!;
  },

  get: async (storeId: string, customerId: string) => {
    const res = await client.get<ApiResponse<{ customer: Customer; recentOrders: unknown[] }>>(
      `/dashboard/${storeId}/customers/${customerId}`,
    );
    return res.data.data!;
  },

  getTimeline: async (storeId: string, customerId: string, params?: { limit?: number; before?: string }) => {
    const res = await client.get<ApiResponse<{ events: Array<{ event: string; data: Record<string, unknown>; timestamp: string }>; hasMore: boolean }>>(
      `/dashboard/${storeId}/customers/${customerId}/timeline`,
      { params },
    );
    return res.data.data!;
  },

  exportCsv: async (storeId: string, params?: { startDate?: string; endDate?: string }) => {
    const res = await client.post<ApiResponse<{ data: string }>>(
      `/dashboard/${storeId}/customers/export`,
      params,
    );
    return res.data.data!;
  },
};
